import * as m from "../../../core/model/model";

type PaymentValidationRulesDto = m.Bokio.Bank.Contract.Dtos.PaymentValidationRulesDto;

export const paymentMessageValidCharacters = (value: string) => /^[ a-zA-Z0-9Ã¥Ã¤Ã¶Ã…Ã„Ã–,.-]+$/.test(value);

export const getNextBusinessDay = (date: m.Day, rules: PaymentValidationRulesDto): m.Day => {
	let nextDay = m.Day.clone(date);
	while (rules.NonBankingDays.some(d => d.Date.equals(nextDay))) {
		nextDay = nextDay.addDays(1);
	}
	return nextDay;
};
